import { HStack, Skeleton, VStack } from '@cdl/heartbeat-react';
import { useOnResizeValue } from '../../../../shared/hooks/useOnResizedValue';
import { LoadingBaseClusters } from './LoadingBaseClusters';

const BEAT_STRIP_WIDTH = 510;
const BEAT_STRIP_HEIGHT = 120;
const BEAT_STRIP_NUMBER = 3;

export const LoadingCleaning: React.FC = () => {
  const height = useOnResizeValue(() => window.innerHeight * 0.3);
  const width = useOnResizeValue(() => window.innerWidth * 0.3);
  return (
    <LoadingBaseClusters>
      <HStack alignItems='center' justifyContent='center' spacing='l'>
        <VStack spacing='m'>
          <Skeleton variant='heartbeat' width={width} height={height} />
          <Skeleton variant='heartbeat' width={width} height={height} />
        </VStack>
        <VStack alignItems='stretch'>
          <VStack alignItems='stretch'>
            <HStack alignItems='start' justifyContent='space-between'>
              <Skeleton width={200} height='1rem' variant='heartbeat' />
              <Skeleton width={170} height='2rem' variant='heartbeat' />
            </HStack>
            <Skeleton width={170} height='2rem' variant='heartbeat' />
          </VStack>
          {Array.from(Array(BEAT_STRIP_NUMBER), (_x, i) => i).map((i) => (
            <Skeleton
              key={i}
              variant='heartbeat'
              width={BEAT_STRIP_WIDTH}
              height={BEAT_STRIP_HEIGHT}
            />
          ))}
        </VStack>
      </HStack>
    </LoadingBaseClusters>
  );
};
